export const targetTypeConstants = {
  SERIAL_NUMBER: "SERIAL_NUMBER",
  REGIONAL: "REGIONAL",
  PHYSICAL: "PHYSICAL",
  VIRTUAL: "VIRTUAL",
  VERSION: "VERSION",
};
